// Function to format round names for display
export const formatRound = (round: string): string => {
    switch (round) {
      case 'GROUP':
        return 'בתים';
      case 'ROUND_OF_32':
        return 'שלב 32';
      case 'ROUND_OF_16':
        return 'שמינית גמר';
      case 'QUARTER_FINAL':
        return 'רבע גמר';
      case 'SEMI_FINAL':
        return 'חצי גמר';
      case 'THIRD_PLACE':
        return 'מקום שלישי';
      case 'FINAL':
        return 'גמר';
      case 'TOURNAMENT':
        return 'טורניר';
      default:
        return round;
    }
  };